import React, { memo } from 'react'

const Title = ({ content = '', className = '', type = '' }) => {
  if (type === 'subtitle')
    return (
      <span className={`auth_form_title span ${className}`}>{content}</span>
    )
  return <h2 className={`auth_form_title h2 ${className}`}>{content}</h2>
}

export default memo(Title)
